import React, {useState} from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TableSortLabel,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Dialog,
} from "@material-ui/core";
import { TableStyle } from "./style";

import { fuelSurchargeHistoryListingHeader } from "@utils/constant";
import moment from "moment-timezone";
import Pagination from "@components/pagination";
import ConfirmPopup from "./popup/confirm-popup";
import ConflictPopup from "./popup/conflict-popup";
import closeIcon from "@assets/images/close.svg";
import FuelSurchargePopup from "./popup/fuel-surcharge-popup";
import { toast } from "react-toastify";
import API from "@services/axios";
import Loader from "@components/loader";
import { utcToLocal } from "@utils/commonFunctions";

function TableListing(props) {
	const classes = TableStyle();
  const [openUpdatePopup, setOpenUpdatePopup] = useState(false);
  const [open, setOpen] = useState(false);
  const [dataFuel, setDataFuel] = useState({});
  const [loading, setLoading] = useState(false);
  const [openConflictDialog, setOpenConflictDialog] = useState(false);

  const handleUpdatePopup = async (id, status) => {
    setLoading(true);
    try {
      const response = await API.get(`customers/fuelSurcharge/${id}`);
      setDataFuel(response?.data?.data);
      setOpen(true);
    } catch (err) {
      toast.error(err?.response?.data?.message || "Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  const addSubmitHandle = (e) => {
    e.preventDefault();
    setOpen(false);

    if (dataFuel?.status === "Active") {
      if (props?.scheduledStartDate && dataFuel?.endDate) {
        if (new Date(props.scheduledStartDate) <= new Date(dataFuel?.endDate)) {
          setOpenConflictDialog(true);
          return;
        }
      }
    }

    handleUpdateFuelSurcharge();
  };

  const handleUpdateFuelSurcharge = async () => {
    const currentDate = utcToLocal(null, dataFuel?.cities?.timezone, "YYYY-MM-DD");
    const endDate = dataFuel?.endDate ? utcToLocal(dataFuel?.endDate, dataFuel?.cities?.timezone, "YYYY-MM-DD") : (dataFuel?.status === "Scheduled" ? dataFuel?.startDate : currentDate);
    if (dataFuel?.status === "Scheduled" ? (endDate > dataFuel?.startDate) : (endDate > currentDate)) {
      setLoading(true);
      try {
        await API.put(`customers/fuelSurcharge/${dataFuel.id}`, { endDate });
        props.updatedFuelSurchargeRate.current = false;
        if (!props.existingActiveStartDate) {
          props.tempFuelSurchargeRate.current = null;
        }
        props.getFuelSurchargeHistory();
        props.getFuelSurchargeEffectiveRates();
        toast.success("Fuel Surcharge Updated Successfully");
      } catch (err) {
        toast.error(err?.response?.data?.message || "Something went wrong");
      } finally {
        setLoading(false);
      }
    } else {
      setOpenUpdatePopup(true);
    }
  }

  return (
    <>
      <Loader loading={loading} />
      <div className={classes.TableWrapper}>
        <TableContainer component={Paper} className={classes.customTable}>
          <Table stickyHeader aria-label="simple table">
            <TableHead>
              <TableRow>
                {fuelSurchargeHistoryListingHeader.map((item, index) => {
                  return (
                    <TableCell key={index} className={item.className}>
                      {item.title}
                      {item.sort && (
                        <TableSortLabel
                          direction={
                            props.orderBy === item.sortTitle
                              ? props.order
                              : "desc"
                          }
                          active={true}
                          onClick={(e) => props.handleSorting(e, item)}
                        ></TableSortLabel>
                      )}
                    </TableCell>
                  );
                })}
              </TableRow>
            </TableHead>
            <TableBody>
              {props?.data?.rows?.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={7} className={classes.dataEmpty}>
                    <span>No Data Found</span>
                  </TableCell>
                </TableRow>
              ) : (
                props?.data?.rows?.map((item, index) => (
                  <TableRow key={index}>
                    <TableCell className="startDate">
                      {item?.startDate ? moment(item?.startDate).format("DD-MM-YYYY") : "-"}
                    </TableCell>
                    <TableCell className="endDate">
                      {item?.endDate ? moment(item?.endDate).format("DD-MM-YYYY") : "-"}
                    </TableCell>
                    <TableCell className="fuelSurcharge">
                      {item.fuelSurcharge ? item.fuelSurcharge : "0"}
                    </TableCell>
                    <TableCell className="status">
                      {item.status ? item.status : "-"}
                    </TableCell>
                    <TableCell className="lastUpdated">
                      {item?.updatedAt ? moment(item?.updatedAt).format("DD-MM-YYYY HH:mm:ss") : "-"}
                    </TableCell>
                    <TableCell className="updatedBy">
                      {item.users?.name ? item.users.name : "-"}
                    </TableCell>
                    <TableCell className="action">
                      {["Active", "Scheduled"].includes(item.status) ? (
                        <span className={classes.cancel} onClick={() => handleUpdatePopup(item?.id, item.status)}>UPDATE</span>
                      ) : "-"}
                    </TableCell>
                  </TableRow>
                ))
              )}
            </TableBody>
          </Table>
        </TableContainer>
        {props?.data?.count !== 0 && (
          <div className="pagination-wrapper">
            <Pagination
              count={props?.data?.count}
              page={props.page}
              handleChangePage={props.handleChangePage}
              rowsPerPage={props.rowsPerPage}
              handleChangeRowsPerPage={props.handleChangeRowsPerPage}
            />
          </div>
        )}
        <ConflictPopup
          open={openConflictDialog}
          handleClose={() => setOpenConflictDialog(false)}
          handleUpdateFuelSurcharge={handleUpdateFuelSurcharge}
          scheduledFuelSurchargeRate={props?.scheduledFuelSurchargeRate}
          scheduledStartDate={props?.scheduledStartDate}
          loading={loading}
        />

        <ConfirmPopup
          open={openUpdatePopup}
          handleClose={() => setOpenUpdatePopup(false)}
          getInfoUpdate={dataFuel}
          getCustomer={props.getCustomer}
          getFuelSurchargeHistory={props.getFuelSurchargeHistory}
          tempFuelSurchargeRate={props.tempFuelSurchargeRate}
          tempErrorFuelSurchargeRate={props.tempErrorFuelSurchargeRate}
          updatedFuelSurchargeRate={props.updatedFuelSurchargeRate}
          existingActiveStartDate={props.existingActiveStartDate}
        />
        <Dialog open={open} className={classes.customModal}>
          <div className="close-modal">
            <img src={closeIcon} alt="Close" onClick={() => setOpen(false)} />
          </div>
          <form
            noValidate
            autoComplete="off"
            className={classes.customForm}
            onSubmit={addSubmitHandle}
          >
            <DialogTitle>Edit Fuel Surcharge</DialogTitle>
            <DialogContent>
              <FuelSurchargePopup
                getDataFuel={dataFuel}
                setDataFuel={setDataFuel}
              />
            </DialogContent>
            <DialogActions className="bottom-button-block">
              <Button
                className="primary-btn gray-border-btn"
                color="inherit"
                disableElevation
                underlinenone="true"
                onClick={() => setOpen(false)}
              >
                Cancel
              </Button>
              <Button
                className="orange-btn primary-btn"
                color="inherit"
                disableElevation
                underlinenone="true"
                type="submit"
              >
                Save
              </Button>
            </DialogActions>
          </form>
        </Dialog>
      </div>
		</>
	);
}
export default TableListing;
